export {default as info} from './info.js'
export {default as map} from './map.js'
import list from './location'
export { list }

let startItem = {
  shirase: '観測隊公室',
  east: '発電棟前',
  west: '防火区画C前',
}

export const startNumber = Object.fromEntries(Object.keys(startItem).map(key => {
  return [ key, list.findIndex(item => item.description == startItem[key]) ]
}))

export const initialView = 0

/*
export const sensors = [
  {
    target: './data/R0010132.jpg',
    size: 560,
    position: [ -60.13, -1318.53, -4816.03 ],
    data: {
      type: 'pole',
      image: 'data/pole01.png',
    },
  },
]
*/

